export default __webpack_public_path__ + "static/media/invisible.e402b65a.svg";